export interface ChangeShelfTypeTempRequest {
  collections: {
    id: number
    revision: number
  }[]
  newShelfType: string
  handlingType: string
  handlingTypeErase: boolean
  _isUpdateChildCollection: boolean
}

export function ChangeShelfTypeTempRequestToJSON(
  value: ChangeShelfTypeTempRequest
): any {
  return {
    collections:
      value.collections.length > 0
        ? value.collections.map(collection => {
            return {
              id: collection.id !== 0 ? collection.id : undefined,
              revision:
                collection.revision !== 0 ? collection.revision : undefined
            }
          })
        : undefined,
    new_shelf_type: value.newShelfType !== '' ? value.newShelfType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    handling_type_erase: value.handlingTypeErase ?? undefined,
    _is_update_child_collection: value._isUpdateChildCollection ?? undefined
  }
}
